/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".comments-title[_ngcontent-%COMP%], .load-more[_ngcontent-%COMP%]{margin-top:16px}.comments__load-more-button[_ngcontent-%COMP%]{height:40px;width:100px}.divider[_ngcontent-%COMP%]{margin-left:10px;margin-right:10px;margin-top:8px}"];
export { styles as styles };
